<template>
  <div class="p-3 bg-white">
    <h3 class="mb-5" v-text="`${$tc('extension', 1)}: ${this.$route.params.extension}`"></h3>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
        <vx-card id="viewExtensionStatusContainer" :title="$t('extension_status_history')" class="mb-8 vs-con-loading__container">
          <shared-extension-status-data-analysis-status-list
            :records="extensionStatusHistoryResults"
          ></shared-extension-status-data-analysis-status-list>
        </vx-card>
      </div>
      <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
        <vx-card id="viewExtensionStatusContainer" :title="$t('call_history')" class="mb-8 vs-con-loading__container">
          <shared-extension-status-data-analysis-call-list
            :records="callHistoryResults"
          ></shared-extension-status-data-analysis-call-list>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>

import SharedExtensionStatusDataAnalysisStatusList from '@/views/Shared/ExtensionStatusDataAnalysis/StatusList.vue'
import SharedExtensionStatusDataAnalysisCallList from '@/views/Shared/ExtensionStatusDataAnalysis/CallList.vue'
import ExtensionStatusDataAnalysis from '@/models/ExtensionStatusDataAnalysis'

export default {
  name: 'Window.ExtensionStatusDataAnalysis.View',
  components: {
    SharedExtensionStatusDataAnalysisStatusList,
    SharedExtensionStatusDataAnalysisCallList
  },
  data () {
    return {
      extensionStatusHistoryResults: {},
      callHistoryResults: {},
      searchParams: {
        date: typeof this.$route.query.date !== 'undefined' ? this.$route.query.date : '',
        extension: this.$route.params.extension
      }
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    async initData () {
      this.$vs.loading({container: '#viewExtensionStatusContainer'})
      const response = await ExtensionStatusDataAnalysis.viewExtension({ ...this.searchParams })
      this.extensionStatusHistoryResults = response.data.extensionStatusHistoryResults
      this.callHistoryResults = response.data.callHistoryResults
      this.$vs.loading.close('#viewExtensionStatusContainer > .con-vs-loading')
    }
  }
}
</script>

<style scoped>

</style>
